import { useEffect } from 'react';

const AttractorTimeout = (config, passRefUpward) => {
    const warningTimeout = () => {
        passRefUpward && passRefUpward(false, true);
    };

    const attractorTimeout = () => {
        passRefUpward && passRefUpward(true, false);
    };

    const throttle = (func, limit) => {
        let lastFunc;
        let lastRan;
        return function() {
            const context = this
            const args = arguments
            if (!lastRan) {
                func.apply(context, args)
                lastRan = Date.now()
            } else {
                clearTimeout(lastFunc)
                lastFunc = setTimeout(function() {
                    if ((Date.now() - lastRan) >= limit) {
                        func.apply(context, args)
                        lastRan = Date.now()
                    }
                }, limit - (Date.now() - lastRan))
            }
        }
    }

    const timeoutDelay = config.timeout.timeout_delay * 1000;
    const timeoutLength = config.timeout.timeout_warning_length * 1000;

    let warningTimeoutId, redirectTimeoutId;

    const mouseMove = () => {
        clearTimeout(redirectTimeoutId);
        clearTimeout(warningTimeoutId);
        passRefUpward && passRefUpward(false, false);
        warningTimeoutId = setTimeout(warningTimeout, timeoutDelay);
        redirectTimeoutId = setTimeout(attractorTimeout, timeoutDelay + timeoutLength);
        // console.log('timeouts');
    };

    const debouncedMouseMove = throttle(mouseMove, 1000)

    useEffect(() => {
        mouseMove();
        window.addEventListener('mousemove', mouseMove, true);
        window.addEventListener('keydown', mouseMove, true);
        window.addEventListener('start-button-press', mouseMove, true);
        window.addEventListener('input-change', mouseMove, true);
        window.addEventListener('touchmove', debouncedMouseMove, true);

        const globeCanvas = document.getElementById('globe-canvas');
        if (globeCanvas) {
            globeCanvas.addEventListener('touchmove', debouncedMouseMove, true);
        }
        // console.log('ADDED EVENT LISTENER');

        return () => {
            clearTimeout(redirectTimeoutId);
            clearTimeout(warningTimeoutId);
            window.removeEventListener('mousemove', mouseMove, true);
            window.removeEventListener('keydown', mouseMove, true);
            window.removeEventListener('input-change', mouseMove, true);
            window.removeEventListener('touchstart', mouseMove, true);
            // console.log('remove');
        }
        // eslint-disable-next-line
    }, []);
};

export default AttractorTimeout;
